// File generated by build script, see package.json
export const FLUTTER_APPS = {
  ancillary_services_app_surge: 'https://flutter-monorepo-quickly-deploy-afidium.surge.sh/ancillary-services-app/#/',
  ancillary_services_summary_app_surge: 'https://flutter-monorepo-quickly-deploy-afidium.surge.sh/ancillary-services-summary-app/#/',
  ancillary_services_list_app_surge: 'https://flutter-monorepo-quickly-deploy-afidium.surge.sh/ancillary-services-list-app/#/',
  ancillary_services_app: 'js/assets/node_modules/@afidium/ancillary-services-app-dist/index.html',
  ancillary_services_summary_app: 'js/assets/node_modules/@afidium/ancillary-services-summary-app-dist/index.html',
  ancillary_services_list_app: 'js/assets/node_modules/@afidium/ancillary-services-list-app-dist/index.html',
};